import { Button } from "@/components/ui/atoms/Button";
import { Card, Typography } from "@/components/ui/atoms";
import { XIcon } from "lucide-react";

interface EmptyStatePanelProps {
  hasFiltersApplied: boolean;
  onClearFilters: () => void;
}

export function EmptyStatePanel({ hasFiltersApplied, onClearFilters }: EmptyStatePanelProps) {
  return (
    <Card variant="custom" rounded="xl" className="rounded-2xl bg-white p-8 text-center">
      <Typography variant="h5">No results found</Typography>
      <Typography as="p" variant="body-sm" color="muted" className="mt-2">
        Try another keyword or remove some filters to see more posts.
      </Typography>
      {hasFiltersApplied ? (
        <div className="mt-5">
          <Button
            type="outlined"
            intent="secondary"
            size="sm"
            label="Clear filters"
            icon={<XIcon/>}
            onClick={onClearFilters}
          />
        </div>
      ) : null}
    </Card>
  );
}
